// Auth calls
import request from 'superagent'
import { API_URL, CLIENT_ID, CLIENT_SECRET } from './const'
import { extractBody } from './helpers'

const fbLogin = () => {
  return new Promise((resolve, reject) => {
    window.FB.login(
      response => {
        if (response.authResponse) {
          resolve(response)
        } else {
          reject()
        }
      },
      { scope: 'email' }
    )
  })
}

export const fbMe = () => {
  return fbLogin().then(loginResponse => {
    return new Promise((resolve, reject) => {
      window.FB.api('/me', { fields: 'email,name' }, response => {
        if (!response || response.error) {
          reject(response)
        } else {
          resolve({
            login: loginResponse.authResponse,
            me: response,
          })
        }
      })
    })
  })
}

// Basic oauth call
const oauth = grantType =>
  request.post(`/oauth/v2/token`).send({
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: grantType,
  })

export const login = ({ username, password }) =>
  oauth('password').send({ username, password }).then(({ body }) => body)

export const loginFacebook = ({ accessToken }) =>
  // <3 js
  (accessToken
    ? Promise.resolve(accessToken)
    : fbLogin().then(
        response => response.authResponse.accessToken
      )).then(accessToken =>
    oauth('http://swapick.com/grants/facebook')
      .send({ password: accessToken })
      .then(({ body }) => body)
  )

export const me = accessToken =>
  request
    .get(`${API_URL}/user`)
    .set('Authorization', `Bearer ${accessToken}`)
    .then(extractBody)

export const refreshToken = refreshToken =>
  oauth('refresh_token').send({ refresh_token: refreshToken }).then(extractBody)

export const register = registrationData =>
  oauth('client_credentials')
    .then(extractBody)
    .then(({ access_token }) =>
      request
        .post(`${API_URL}/users`)
        .set('Authorization', `Bearer ${access_token}`)
        .send({ fos_user_registration_form: registrationData })
        .then(extractBody)
    )

export const resetPassword = username =>
  oauth('client_credentials')
    .then(extractBody)
    .then(({ access_token }) =>
      request
        .post(`${API_URL}/passwords/resets`)
        .set('Authorization', `Bearer ${access_token}`)
        .send({ username })
    )



// WEBPACK FOOTER //
// ./src/api/auth.js